module.exports = __webpack_public_path__ + "static/company-86b9fe7c3a1f8c6d2bf8a347e1772df4.svg";